import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const incrementInventory = unaryRpc({
  name: "incrementInventory" as const,
  input: z.object({
    team: z.string(),
    originalTeamId: z.string().optional(),
    locationId: z.string(),
    variantId: z.string(),
    quantity: z.number(),
  }),
  output: z.null().optional(),
});
